import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import { type SkeletonVariantProps, skeleton } from '@repo/pandacss/recipes';
import type { WithCss } from '@repo/pandacss/types';
import type { ComponentPropsWithRef } from 'react';
export type SkeletonProps = SkeletonVariantProps & WithCss & ComponentPropsWithRef<'span'>;
export function Skeleton(t0) {
  const $ = _c(14);
  let animation;
  let className;
  let cssProp;
  let props;
  let variant;
  if ($[0] !== t0) {
    ({
      variant,
      animation,
      css: cssProp,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = animation;
    $[2] = className;
    $[3] = cssProp;
    $[4] = props;
    $[5] = variant;
  } else {
    animation = $[1];
    className = $[2];
    cssProp = $[3];
    props = $[4];
    variant = $[5];
  }
  let t1;
  if ($[6] !== animation || $[7] !== className || $[8] !== cssProp || $[9] !== variant) {
    t1 = cx(skeleton({
      variant,
      animation
    }), css(cssProp), className);
    $[6] = animation;
    $[7] = className;
    $[8] = cssProp;
    $[9] = variant;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== props || $[12] !== t1) {
    t2 = <span {...props} className={t1} />;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}